import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private translations = new BehaviorSubject<any>({});
  public currentLanguage: string = 'en';

  constructor(private http: HttpClient) {
    const savedLang = localStorage.getItem('language');
    if (savedLang) {
      this.currentLanguage = savedLang;
    }
    this.loadTranslations(this.currentLanguage);
    this.setDir(this.currentLanguage); 
  }

  private loadTranslations(lang: string): void {
    const path = `assets/translations/${lang}.json`;
    this.http.get(path).subscribe((data) => {
      this.translations.next(data);
    });
  }

  setLanguage(lang: string): void {
    this.currentLanguage = lang;
    localStorage.setItem('language', lang); 
    this.loadTranslations(lang);
    this.setDir(lang);
  }

  private setDir(lang: string): void {
    const dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
  }

  getTranslation(key: string): string {
    const translations = this.translations.getValue();
    return key.split('.').reduce((obj, keyPart) => obj?.[keyPart], translations) || key;
  }
}
